<template>
  <div>
    <v-card class="transparent elevation-0">
      <v-container container--fluid grid-list-md>
        <v-row>
          <v-col cols="12" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
            <h1>Validate Address</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="18" md="8">
            <v-combobox
              clearable
              label="Address"
              :items="renderedInfo"
              v-model="address"
              :search-input.sync="addressSelected"
              prepend-icon="fas fa-map-marker-alt"
              @input="validate"
            ></v-combobox>

          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="2">
            <v-row align="center">
              <v-col cols="14" md="8" class="text-center">
                <v-tooltip top color="secondary">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="mx-2"
                      dark
                      color="blue lighten-1"
                      @click="validate"
                      v-on="on"
                    >Validate</v-btn>
                  </template>
                  <span>Validate Address</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="addressValidate"
        hide-default-footer
      >
        <template v-slot:item="props">
          <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td v-if="header.text !== 'Zone' && header.text !== 'Depot'" style="text-align: center" v-for="(header, index) in headers" :key="index"
             >
              {{props.item[header.value]}}
            </td>
            <td v-else-if="header.text === 'Zone'" style="text-align: center">
              {{renderedTimeWindows.name}}
            </td>
            <td v-else style="text-align: center">
              {{renderedTimeWindows.depot_name}}
            </td>

          </tr>
        </template>
      </v-data-table>
    </v-card>
    <v-divider></v-divider>


      <v-card v-if="found">
        <v-divider></v-divider>
        <v-container container--fluid grid-list-md>
          <v-row align="center" >
            <v-col cols="12" md="3">
              <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
            </v-col>
            <v-col cols="12" md="2" >
            </v-col>
            <v-col cols="12" md="4">
              <h3>Time Windows</h3>
            </v-col>
          </v-row>
        </v-container>

        <v-divider></v-divider>

        <v-card-text :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
          <v-container container--fluid grid-list-xl pb-0>

            <v-data-table
              :headers="timeHeaders"
              :items="renderedTimeWindows.time_windows"
              :search="search"
            >
              <template v-slot:item="props">
                <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
                  <td style="text-align: center" v-for="(header, index) in timeHeaders" :key="index">
                    {{props.item[header.value]}}
                  </td>

                </tr>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
      </v-card>

      <v-card v-else>
        <v-card-title class="d-flex" style="position: relative" :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
          <h2>Time Windows</h2>

        </v-card-title>
        <v-divider></v-divider>
        <v-container container--fluid grid-list-md>
          <v-row align="center" >
            <v-col cols="14" md="14" >
              <h3 style="color:red">{{address === null ? 'This address is outside of delivery' : address + ' is outside of delivery'}}</h3>
            </v-col>
          </v-row>
        </v-container>

        <v-divider></v-divider>

      </v-card>



  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ValidateAddress",
  data() {
    return {
      valid: false,
      reload: false,
      addressValidate: [],
      dialog: false,
      search:'',

      timeHeaders:[
        {text: 'Day', value: 'day', align: 'center', sortable: true},
        {text: 'Time Start', value: 'time_start', align: 'center', sortable: true},
        {text: 'Time End', value: 'time_end', align: 'center', sortable: true},
      ],

      address:null,
      addressSelected:null,

      timeSelected:{
        postcode:null,
        locations:false,
        show_all:true,
        timewindows:true,
      },
      found:true,
      info:'',


    }
  },
  methods: {
    validate() {
      if(this.address === undefined){
        this.addressValidate = [];
        this.found = false;
        return;
      }
      if (this.address !== null) {
        this.addressValidate = [];
         return axios.get(process.env.API_URL + '/geocode/info?' + 'term=' + this.address)
          .then((response) => {
            this.addressValidate.push(response.data);
            if(response.data.valid === true){
              this.addressValidate[0]['location'] = response.data.latitude.toString() + ' , ' + response.data.longitude.toString();
              this.addressValidate[0]['result'] = 'Yes';
              //search the time windows
              this.timeSelected.postcode = response.data['postcode'];
              this.timeSelected.locations = true;
              this.found = true;
            } else {
              this.addressValidate[0]['result'] = 'No';
              this.found = false;
            }
            return response.data;
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
            return [];
          });
      }

    },
    updateDataTable() {
      this.reload = !this.reload;
    },
  },
  computed: {
    headers(){
       let headers = [
           {text: 'Address', value: 'street1', align: 'center', sortable: false},
           {text: 'Suburb', value: 'suburb', align: 'center', sortable: false},
           {text: 'State', value: 'state', align: 'center', sortable: false},
           {text: 'Postcode', value: 'postcode', align: 'center', sortable: false},
           {text: 'Valid', value: 'result', align: 'center', sortable: false,},
           {text: 'Location', value: 'location', align: 'center', sortable: false,}
         ];
      if (this.found) {
        headers.push({text: 'Zone', value: 'name', align: 'center', sortable: false, width: '10%'});
        headers.push({text: 'Depot', value: 'depot_name', align: 'center', sortable: false, width: '10%'});
      }
      return headers;
    },
    renderedInfo() {
      if (this.addressInfo === null) return [];
      return this.addressInfo
    },
    renderedTimeWindows() {
      if (this.gettimeWindows === null)  return [];
      return this.gettimeWindows;
    },
  },
  asyncComputed: {
    async addressInfo() {
      if (this.addressSelected !== null) {
        return await axios.get(process.env.API_URL + '/geocode/autocomplete?' + 'term=' + this.addressSelected + '&info=' + this.addressSelected)
          .then((response) => {
            return response.data;
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
            return [];
          });
      }
    },

    async gettimeWindows() {
      if (this.reload || !this.reload) {
        return await axios.get(process.env.API_URL + '/zones?' + 'postcode=' + this.timeSelected.postcode
          + '&locations=' + this.timeSelected.locations + '&show_all=' + this.timeSelected.show_all +'&timewindow=' + this.timeSelected.timewindows)
          .then((response) => {
            this.found = true;
            return response.data;
          })
          .catch((response) => {
            this.found = false;
             // this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
            return [];
          });
      }
    },


  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/ValidateAddress.vue